var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.2 20",
    style: {
      enableBackground: "new 0 0 12.2 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2,9.9C11.5,8.4,10.5,7,9.5,5.7C8.3,3.8,7.2,1.9,6.2,0.1C5.9-0.1,5.9,0.2,5.8,0.4C5.7,0.6,5.5,0.9,5.4,1.1 c-0.3,0.6-0.7,1.2-1,1.8c-1.3,2.4-2.9,4.7-4.3,7l0,0c-0.2,0.2,0.4,0.8,0.5,1c0.8,1.4,1.7,2.8,2.4,4.2c0.6,1.2,1.5,2.2,2.1,3.4 c0.2,0.2,0.8,1.7,1.1,1.4c1.1-1.8,2.3-3.7,3.6-5.6c0.8-1.4,1.5-2.9,2.4-4.3C12.2,10.1,12.2,10,12.2,9.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.bb93eba207136d5e67fb8fe148884c8b.svg";
export { ForwardRef as ReactComponent };